import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    width: 'max-content',
    gap: 4,
    lineHeight: 1,
  },
  craftviewLogo: {
    filter: theme.palette.type === 'light' ? 'brightness(0)' : 'none',
  },
  backstage: {
    fontSize: 10,
    letterSpacing: '1.5px',
    textTransform: 'uppercase',
    fontFamily: theme.typography.fontFamily,
    color: theme.palette.type === 'dark' ? '#7df3e1' : '#00897b',
  },
}));

const LogoFull = () => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <img
        src="/logo-craftview.png"
        alt="Craftview"
        className={classes.craftviewLogo}
        style={{ height: 28, width: 'auto' }}
      />
      <span className={classes.backstage}>Backstage</span>
    </div>
  );
};

export default LogoFull;
